import en from './en/translation.json'
import ja from './ja/translation.json'

export default { en, ja }
